import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
// No longer needs useVehiclesStore
// import { devLog } from '~/utils/logger'

// Removed CartItem interface

export const useVehicleStore = defineStore('vehicle', () => {
  // Removed mainStore dependency
  
  // State - Keep only interaction-related state
  const loading = ref(false) // Keep generic loading/error?
  const error = ref<string | null>(null)
  const recentlyViewed = ref<string[]>([]) // Keep recently viewed IDs
  // Removed cartItems, isCartOpen
  
  // Getters - Keep only recentlyViewedVehicles, adjust its dependency
  const recentlyViewedVehicles = computed(() => {
    // This getter now needs access to the main vehicle list somehow.
    // Option 1: Import useVehiclesStore here (creates coupling)
    // Option 2: Remove this getter, components using it must fetch details themselves.
    // Let's go with Option 2 for now to decouple stores.
    // Components needing details for recently viewed items will fetch them.
    console.warn('recentlyViewedVehicles getter removed from vehicleStore. Components need to fetch details.');
    return []; // Return empty or adjust as needed
  })

  // Removed cartTotal, cartCount, isInCart, vehicles, getVehicleById
  
  // Actions - Keep only interaction-related actions
  
  // Removed fetchVehicleById, cart actions, getSimilarVehicles, refreshVehicles

  /**
   * Add vehicle ID to recently viewed list
   */
  const addToRecentlyViewed = (vehicleId: string) => {
    if (!vehicleId) return;
    // Remove if already exists (to move it to the front)
    recentlyViewed.value = recentlyViewed.value.filter(id => id !== vehicleId)
    // Add to the front of the array
    recentlyViewed.value.unshift(vehicleId)
    // Limit to 10 recently viewed vehicles
    if (recentlyViewed.value.length > 10) {
      recentlyViewed.value = recentlyViewed.value.slice(0, 10)
    }

  }
  
  /**
   * Increment view count for a vehicle by calling the server-side API.
   * Returns the API response which includes the updated view count.
   */
  const incrementViewCount = async (vehicleId: string): Promise<{ success: boolean; viewCount: number; alreadyCounted: boolean; error?: string } | null> => {
    if (!vehicleId) {
  
      return null;
    }
    
    // Validate vehicleId format
    if (typeof vehicleId !== 'string' || vehicleId.trim().length === 0) {
      console.error(`Invalid vehicleId format: ${vehicleId}`);
      return { success: false, viewCount: 0, alreadyCounted: false, error: 'Invalid vehicle ID format' };
    }
    

    try {
      const response = await $fetch(`/api/vehicles/${vehicleId}/increment-view`, {
        method: 'POST',
      }) as { success: boolean; viewCount: number; alreadyCounted: boolean; error?: string };

      return response;
    } catch (error: any) {
      console.error(`Error calling increment view count API for ${vehicleId}:`, error);
      
      // Provide more specific error messages based on status code
      let errorMessage = 'Failed to increment view count';
      if (error.statusCode === 400) {
        errorMessage = 'Invalid vehicle ID or request format';
      } else if (error.statusCode === 500) {
        errorMessage = 'Server configuration error';
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      return { success: false, viewCount: 0, alreadyCounted: false, error: errorMessage };
    }
  }
  
  return {
    loading, // Keep if used for incrementViewCount?
    error,   // Keep if used for incrementViewCount?
    recentlyViewed, // Expose the IDs
    // recentlyViewedVehicles, // Getter removed
    addToRecentlyViewed,
    incrementViewCount
  }
}, {
  persist: {
    // paths: ['recentlyViewed'], // Removed - Not needed with custom storage
    storage: {
      getItem: (key: string): string | null => {
        if (process.client) {
          return localStorage.getItem(key)
        }
        return null 
      },
      setItem: (key: string, value: string): void => {
        if (process.client) {
          localStorage.setItem(key, value)
        }
      },
    }
  }
})
